import React, { createContext, useCallback, useEffect, useState } from 'react'
import FlagProvider from '@unleash/proxy-client-react'
import OrbitApiV1 from 'api/orbitV1'
import axios from 'axios'
import PropTypes from 'prop-types'
import unleashConfig from 'services/Unleash'

import OrbitSession from '../hooks/useCookies'

export const FlagContext = createContext({})

/**
 * Selects the flag provider (default: Unleash) based on the health of the server
 * @param {node} children - page routes
 * @returns Provider
 */
export const OrbitFlagProvider = ({ children }) => {
  const [flags, setFlags] = useState([])

  const getFlags = useCallback(async () => {
    try {
      const flagsResponse = await OrbitApiV1.httpGet(
        '/featureFlags/getAllFlags'
      )
      if (flagsResponse && flagsResponse.data.data) {
        setFlags(flagsResponse.data.data)
      }
    } catch (err) {
      throw new Error(err)
    }
  })

  useEffect(() => {
    getFlags()
  }, [])

  // ping for the health status of unleash
  const isHealthy = useCallback(async (provider) => {
    if (provider === 'unleash') {
      try {
        const { data: unleashHealth } = await axios({
          method: 'get',
          url: `${unleashConfig.url}/health`,
          headers: {}
        })

        return unleashHealth === 'ok'
      } catch (err) {
        return false
      }
    }
  })

  // do a health check on Unleash
  // if healthy, return Unleash's FlagProvider
  if (isHealthy('unleash')) {
    OrbitSession.set({ provider: 'UL' })

    return <FlagProvider config={unleashConfig}>{children} </FlagProvider>
  } else {
    OrbitSession.set({ provider: 'OB' })
    return <FlagContext.Provider value={flags}>{children}</FlagContext.Provider>
  }
}

OrbitFlagProvider.propTypes = {
  children: PropTypes.node
}

export default OrbitFlagProvider
